/**
 * Badge definitions for the "Let 'Em Cook" system.
 * Badges are earned by accumulating praise and reactions in rolling windows.
 */

export const BADGES = {
  let_em_cook: { label: "Let 'Em Cook", emoji: '\u{1F373}', color: 'text-orange-400', bg: 'bg-orange-500/10' },
  cookin:      { label: "Cookin'",       emoji: '\u{1F525}', color: 'text-red-400',    bg: 'bg-red-500/10' },
  on_point:    { label: 'On Point',      emoji: '\u{1F4AF}', color: 'text-amber-400',  bg: 'bg-amber-500/10' },
  real_one:    { label: 'Real One',       emoji: '\u{1F451}', color: 'text-yellow-400', bg: 'bg-yellow-500/10' },
  mvp:         { label: 'MVP',            emoji: '\u{1F3C6}', color: 'text-purple-400', bg: 'bg-purple-500/10' },
};

/**
 * Get the highest-priority badge from a list of active badge keys.
 * Priority order: mvp > real_one > cookin > on_point > let_em_cook
 */
const BADGE_PRIORITY = ['mvp', 'real_one', 'cookin', 'on_point', 'let_em_cook'];

export function getTopBadge(activeBadges) {
  if (!activeBadges || activeBadges.length === 0) return null;
  for (const key of BADGE_PRIORITY) {
    if (activeBadges.includes(key)) return { key, ...BADGES[key] };
  }
  return null;
}

export function getBadgeInfo(key) {
  return BADGES[key] ? { key, ...BADGES[key] } : null;
}
